import { createSlice } from '@reduxjs/toolkit';

const products = createSlice({
    name: 'products',
    initialState: {
        allProducts: [],
        lastOrders: [],
        lastOrdersV2: [],
        productsList: []
    },
    reducers: {
        setProducts(state, action) {
            state.allProducts = action.payload;
        },
        setLastOrders(state, action) {
            state.lastOrders = action.payload;
        },
        setLastOrdersV2(state, action) {
            state.lastOrdersV2 = action.payload;
        },
        setProductsList(state, action) {
            // console.log("before set in store=",state)
            state.productsList = action.payload;
        },
    }
})
export const { setProducts, setLastOrders, setLastOrdersV2, setProductsList } = products.actions;

export const selectProducts = (state) => state.products.allProducts;
export const selectLastOrders = (state) => state.products.lastOrders;
export const selectLastOrdersV2 = (state) => state.products.lastOrdersV2;
// console.log("before set in store=",setProductsList)
// export const selectProductsList = (state) => state.products ? state.products.productsList : [];
export const selectProductsList = (state) => state.products.productsList;
export const getProducts = (state, category,subCategory) => {

    let { products:{allProducts} } = state;
    if(allProducts.length > 0){
        // console.log(allProducts, category,subCategory);

        let cat = allProducts.filter(i=>(i.name).toLowerCase() === category.toLowerCase());
        if(cat.length > 0 && subCategory){
            // console.log(cat);
            let subCat = cat[0]?.sub_categories.filter(i=>(i.name).toLowerCase() === subCategory.toLowerCase());
            // console.log(subCat);
            const res= {...cat[0]};
            // console.log(res)
            delete res.sub_categories ;
            let obj =  {...res} ;
            if(subCat.length > 0) obj[`subCategory`] = subCat[0];
            return obj;

        }
        if(cat.length > 0 ){
            return cat[0]
        }
        return cat ;
    }
}

export default products.reducer;

